import { service } from "@/common/axios-service";

// Accept web meeting links and Zoom application links, never executable URLs.
function normalizeMeetingUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  try {
    const url = new URL(value.trim());
    return ['https:', 'http:', 'zoommtg:', 'zoomus:'].includes(url.protocol) && url.hostname
      ? value.trim()
      : '';
  } catch {
    return '';
  }
}
const state = {
  meetingUrl:'',
  meetingType:0,
}

const getters={
  MeetingUrl:(state) => state.meetingUrl,
  MeetingType:(state) => state.meetingType,
}

const actions ={
  async GetTrainingSchedule(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Student/GetSchedule",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async GetBookDetail(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Student/BookDetail",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async PostponeLesson(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Student/PostponeLesson",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async GetTrainingPackageInfo() {
    return new Promise((resolve,reject)=>{
      service.post("Student/TrainingPackageInfo",{})
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async SaveAnswerBookTest(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Student/BookTestResultSave",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async SaveLessonNote(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Student/LessonNoteSave",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  RequestingToJoinLesson() {
    return service.post("Student/RequestingToJoinLesson");
  },
  async AddMeetingUrl({commit}, {signal} = {}) {
    try {
      const res = await service.get("Student/GetMeetingInfo", {signal});
      if (signal?.aborted) return;
      commit("SetMeetingUrl", res?.data || {});
    } catch (error) {
      if (!signal?.aborted) {
        commit("SetMeetingUrl", {});
      }
      throw error;
    }
  },
  async SearchWordCards(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("WordPool/SearchWordCards",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async DeclareAbsence(context, studentScheduleId = 0) {
    if (!Number.isSafeInteger(studentScheduleId) || studentScheduleId <= 0) {
      return Promise.reject({message:'Ders kaydı bulunamadı.'});
    }

    return new Promise((resolve,reject)=>{
      service.post("Student/DeclareAbsence", studentScheduleId)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
}

const mutations ={
  SetMeetingUrl(state,data){
    state.meetingUrl = normalizeMeetingUrl(data.meetingUrl);
    state.meetingType = Number(data.meetingType) || 0;
  }
}

export default{
    state,
    getters,
    actions,
    mutations
};
